module.exports = __webpack_public_path__ + "static/media/Hannah Choi.d1d12d4c.png";